import {inject} from '@angular/core';
import {HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AdminAuthenticationService} from "@app/security/admin-authentication.service";
import {AdminContextService} from "@app/security//admin-context.service";

export class TokenInterceptorHandler {
  constructor(private auth: AdminAuthenticationService,
              private adminContext: AdminContextService) {
  }

  public handleRequest(req: HttpRequest<any>): HttpRequest<any> {
    const headers = new HttpHeaders(this.addSysContextHeaders(req));
    const cloned = req.clone({
      headers: headers
    });
    return cloned;
  }

  private addSysContextHeaders(req: any) {
    let headersObject: { [key: string]: any } = {
      'x-system-id': 'ADMIN'
    }

    if (this.auth.getToken()) {
      headersObject['Authorization'] = `Bearer ${this.auth.getToken()}`;
    }

    const context = {
      principleType: 'admin',
      landlordId: this.adminContext.selectedAdminContext.landlord?.uuid ?? null,
      locationId: this.adminContext.selectedAdminContext.location?.uuid ?? null,
      offeringId: this.adminContext.selectedAdminContext.offering?.uuid ?? null
    };


    if (context.landlordId != null) {
      headersObject['x-landlord-id'] = context.landlordId;
    }

    if (context.locationId != null) {
      headersObject['x-location-id'] = context.locationId;
    }

    if (context.offeringId != null) {
      headersObject['x-offering-id'] = context.offeringId?.toUpperCase()!;
    }

    req.headers.keys().forEach((ea: string) => {
      headersObject[ea as keyof Object] = req.headers.get(ea);
    })

    //todo remove before commit
    return Object.entries(headersObject)
      .reduce((a, [k, v]) => (v === null ? a : (a[k as keyof Object] = v, a)), {});
  }
}

export const tokenInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth: AdminAuthenticationService = inject(AdminAuthenticationService);
  const adminContext: AdminContextService = inject(AdminContextService);
  const tokenInterceptorHandler = new TokenInterceptorHandler(auth, adminContext);
  const cloned = tokenInterceptorHandler.handleRequest(req);
  return next(cloned);
}
